import { PlanSectionSkeleton } from "./PlanSectionSkeleton";
import { CreditsSectionSkeleton } from "./CreditsSectionSkeleton";
import { PaymentHistorySectionSkeleton } from "./PaymentHistorySectionSkeleton";

export function MembershipDashboardSkeleton() {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
      <div className="lg:col-span-2 space-y-8">
        <PlanSectionSkeleton />
        <PaymentHistorySectionSkeleton />
      </div>

      <div className="lg:col-span-1">
        <CreditsSectionSkeleton />
      </div>
    </div>
  );
} 